module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fundao"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "title-header"
  }, [_vm._v("\n                        Bem-vindo ao SGP!\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "texto-principal"
  }, [_c('p', [_vm._v("Parceiro, seu trabalho permite que nosso propósito de "), _c('strong', [_vm._v("“Promover coletivamente caminhos para\ntransformação social e relação sustentável\ncom a Natureza”")]), _vm._v(" de fato se realize! A Fundação BB possui "), _c('b', [_vm._v("Programa de "), _c('b', {
    staticClass: "compliance"
  }, [_vm._v("Compliance")]), _vm._v(" e Integridade")]), _vm._v(", embasado na Lei\n                        12.846/2013, e "), _c('strong', [_vm._v("Código  de Ética")]), _vm._v(", que contém balizadores das melhores práticas de ética, compliance e gestão de riscos. Como forma de colaborarmos com seu trabalho e atuarmos na construção de um\n                        país ético e solidário, sugerimos que acesse e conheça estes documentos institucionais e que busque a realização dos treinamentos abaixo.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "diretoria"
  }, [_vm._v("Diretoria Executiva da Fundação BB")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('div', {
    staticClass: "title-button-container"
  }, [_c('p', {
    staticClass: "conheca"
  }, [_vm._v("Conheça nossos documentos institucionais:")]), _vm._v(" "), _c('div', {
    staticClass: "cta-container"
  }, [_c('a', {
    staticClass: "botaoazul",
    attrs: {
      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Programa_de_Compliance_e_Integridade_Fundacao_BB.pdf",
      "target": "_blank"
    }
  }, [_c('div', [_vm._v("Programa de "), _c('i', [_vm._v("Compliance")]), _vm._v(" e Integridade")]), _vm._v(" "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": "\\static\\img\\DI\\icone_integridade.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "botaoamarelo",
    attrs: {
      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Codigo_de_Etica_Fundacao_BB.pdf",
      "target": "_blank"
    }
  }, [_vm._v(" Código de Ética\n                                "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": "\\static\\img\\DI\\icone_etica.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "botaoamarelo",
    attrs: {
      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Codigo-de-Governanca-Fundacao-BB.pdf",
      "target": "_blank"
    }
  }, [_vm._v(" Código de Governança\n                                "), _c('i', {
    staticClass: "fa fa-file"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cursos-content"
  }, [_c('div', {
    staticClass: "cursosEscolas"
  }, [_c('div', {
    staticClass: "containerUnibb"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#002D4B",
      "width": "300px",
      "border-radius": "5px"
    }
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "\\static\\img\\DI\\logo_unibb.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blocoCursos"
  }, [_c('div', {
    staticClass: "cursos cursoLilas"
  }, [_c('div', {
    staticClass: "descricao"
  }, [_c('div', {
    staticClass: "titulo-curso"
  }, [_vm._v("Prevenção e Combate à Corrupção ")]), _vm._v(" "), _c('div', {
    staticClass: "texto-curso"
  }, [_vm._v("Identificar situações ou negócios que configurem indícios de corrupção, utilizando a definição dos atos lesivos praticados contra a administração pública, em conformidade com as exigências legais.")])]), _vm._v(" "), _c('a', {
    staticClass: "botoesCursos",
    attrs: {
      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/27/lesson/27/1",
      "target": "_blank"
    }
  }, [_vm._v(" Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cursos cursoVerde"
  }, [_c('div', {
    staticClass: "descricao"
  }, [_c('div', {
    staticClass: "titulo-curso"
  }, [_vm._v("Empresas e a Prevenção à Corrupção")]), _vm._v(" "), _c('div', {
    staticClass: "texto-curso"
  }, [_vm._v("Identificar elementos que compõe os diversos aspectos de integridade nas empresas e mecanismos para fortalecê-los dentro da cultura corporativa.\n                               ")])]), _vm._v(" "), _c('a', {
    staticClass: "botoesCursos",
    attrs: {
      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/35/lesson/35/1",
      "target": "_blank"
    }
  }, [_vm._v(" Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cursos cursoRosa"
  }, [_c('div', {
    staticClass: "descricao"
  }, [_c('div', {
    staticClass: "titulo-curso"
  }, [_vm._v("Ação Voluntária: Gestão Financeira")]), _vm._v(" "), _c('div', {
    staticClass: "texto-curso"
  }, [_vm._v("Identificar conceitos e instrumentos de gestão financeira que serão utilizadas em organizações do Terceiro Setor.")])]), _vm._v(" "), _c('a', {
    staticClass: "botoesCursos",
    attrs: {
      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/46/lesson/46/1",
      "target": "_blank"
    }
  }, [_vm._v(" Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cursos cursoLilas"
  }, [_c('div', {
    staticClass: "descricao"
  }, [_c('div', {
    staticClass: "titulo-curso"
  }, [_vm._v("Ação Voluntária: Elaboração e Gestão de Projetos Sociais e Captação de Recursos")]), _vm._v(" "), _c('div', {
    staticClass: "texto-curso"
  }, [_vm._v("Identificar a metodologia de elaboração de projetos, assim como as estratégias de captação de recursos para o Terceiro Setor. ")])]), _vm._v(" "), _c('a', {
    staticClass: "botoesCursos",
    attrs: {
      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/45/lesson/45/1",
      "target": "_blank"
    }
  }, [_vm._v(" Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cursos cursoCinza"
  }, [_c('div', {
    staticClass: "descricao"
  }, [_c('div', {
    staticClass: "titulo-curso"
  }, [_vm._v("Introdução a Mercados de Carbono")]), _vm._v(" "), _c('div', {
    staticClass: "texto-curso"
  }, [_vm._v("Entender conceitos básicos de mudança do clima e mercados de carbono no contexto de mitigação climática.")])]), _vm._v(" "), _c('a', {
    staticClass: "botoesCursos",
    attrs: {
      "href": "https://playerunibb.ciatech.com.br/bancodobrasil-player-frontend/open-course/66/lesson/66/1",
      "target": "_blank"
    }
  }, [_vm._v(" Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "containerEscola"
  }, [_c('div', {
    staticClass: "titulos"
  }, [_c('img', {
    staticClass: "logo-escola",
    attrs: {
      "src": "\\static\\img\\DI\\outros_cursos_logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blocoCursos"
  }, [_c('div', {
    staticClass: "escola-aberta-cursos"
  }, [_c('div', {
    staticClass: "escola escolaLilas"
  }, [_c('div', {
    staticClass: "escolaDescricao"
  }, [_c('div', {
    staticClass: "titulo-curso-escola"
  }, [_vm._v("Governança no Terceiro Setor")])]), _vm._v(" "), _c('a', {
    staticClass: "botaoEscola",
    attrs: {
      "href": "https://www.sebrades.com.br/sebrades-cursos/governanca-no-terceiro-setor/",
      "target": "_blank"
    }
  }, [_vm._v("Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "escola escolaRosa"
  }, [_c('div', {
    staticClass: "escolaDescricao"
  }, [_c('div', {
    staticClass: "titulo-curso-escola"
  }, [_vm._v("ESG e os Objetivos do Desenvolvimento Sustentável")])]), _vm._v(" "), _c('a', {
    staticClass: "botaoEscola",
    attrs: {
      "href": "https://www.escolaaberta3setor.org.br/sebrades-cursos/esg-e-os-objetivos-do-desenvolvimento-sustentavel/",
      "target": "_blank"
    }
  }, [_vm._v("Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "escola cursoVerde"
  }, [_c('div', {
    staticClass: "escolaDescricao"
  }, [_c('div', {
    staticClass: "titulo-curso-escola"
  }, [_vm._v("ESG, o que todo profissional deve saber")])]), _vm._v(" "), _c('a', {
    staticClass: "botaoEscola",
    attrs: {
      "href": "https://inbs.com.br/cursos/esg-o-que-todo-profissional-deve-saber/",
      "target": "_blank"
    }
  }, [_vm._v("Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "escola cursoCinza"
  }, [_c('div', {
    staticClass: "escolaDescricao"
  }, [_c('div', {
    staticClass: "titulo-curso-escola"
  }, [_vm._v("Prevenção à lavagem de dinheiro e ao financiamento do terrorismo")])]), _vm._v(" "), _c('a', {
    staticClass: "botaoEscola",
    attrs: {
      "href": "https://www.escolavirtual.gov.br/curso/217",
      "target": "_blank"
    }
  }, [_vm._v("Acessar "), _c('img', {
    attrs: {
      "src": "\\static\\img\\DI\\icone_acessar.png"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "aviso"
  }, [_c('div', [_vm._v("Clique nos cursos acima e efetue o treinamento. Encaminhe sua experiência sobre os treinamentos para nosso e-mail: "), _c('a', {
    attrs: {
      "href": "mailto:controles@fbb.org.br",
      "target": "_blank"
    }
  }, [_vm._v("controles@fbb.org.br.")])]), _vm._v(" "), _c('div', [_vm._v("Canal de Denúncias BB, Fale Conosco e LGPD: "), _c('a', {
    attrs: {
      "href": "https://fbb.org.br/pt-br/falaconosco2",
      "target": "_blank"
    }
  }, [_vm._v("clique aqui.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28a87cd9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/Integridade.vue
// module id = 1894
// module chunks = 1